import type { Database } from "@/types/supabase.types";
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// Fail fast in development if env vars are missing
if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    "Missing Supabase environment variables. Ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set.",
  );
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
export const analysisClient = supabase.schema("analysis");
export const assistantClient = supabase.schema("assistant");
export const billingPublicClient = supabase.schema("billing_public");
export const miniToolsClient = supabase.schema("mini_tools");
